import { useMemo, useState } from 'react';
import { useOrders } from '../../utils/api.hook';
import { OrderStatisticsComponent } from './order-statistics.component';
import { find, forEach, map } from 'lodash';
import dayjs, { Dayjs } from 'dayjs';

export function OrderStatisticsContainer() {
  const [redeemDate, setRedeemDate] = useState<[Dayjs, Dayjs]>([
    dayjs(),
    dayjs(),
  ]);
  const [orderState, setOrderState] = useState<
    Array<'已確認' | '未確認' | '取消訂單' | '取消訂單-退貨' | '結案'>
  >(['已確認']);
  const {
    data: { orders, locations } = {},
    isLoading,
    isFetching,
  } = useOrders({
    redeemTimeRange: map(redeemDate, (date) => date.toISOString()),
    state: orderState,
  });
  const [locationCounts, providerCounts] = useMemo(() => {
    const locationResult: Record<string, number> = {};
    const providerResult: Record<string, number> = {};
    forEach(orders, (order) => {
      const { quantity, address, providerName } = order;

      locationResult[address] = (locationResult[address] || 0) + quantity;
      providerResult[providerName] =
        (providerResult[providerName] || 0) + quantity;
    });

    return [
      map(locationResult, (value, id) => ({
        id,
        value,
        idNumber: find(locations, ['name', id])?.idNumber || 0,
      })),
      map(providerResult, (value, id) => ({ id, value })),
    ];
  }, [orders, locations]);

  return (
    <OrderStatisticsComponent
      isLoading={isLoading || isFetching}
      onDateChange={setRedeemDate}
      onOrderStateChange={setOrderState}
      redeemDate={redeemDate}
      orderState={orderState}
      locationCounts={locationCounts || []}
      providerCounts={providerCounts || []}
    />
  );
}
